iScreenWizard.factory('Matchingintellectuelecompetentieoptie', function ($q, Ajax) {

    var data = {};

    data.all = function() {
        return $q(function (resolve, reject) {
            Ajax.get('matchingintellectuelecompetentieoptie').then(function (response) {
                var matchingintellectuelecompetentieopties = response.data;
                resolve(matchingintellectuelecompetentieopties);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('matchingintellectuelecompetentieoptie/'+id).then(function (response) {
                var matchingintellectuelecompetentieoptie = response.data;
                resolve(matchingintellectuelecompetentieoptie);
            }, reject);
        });
    };

    return data;
});